<template>
    <section class="row align-items-center padding-top-2x padding-bottom-2x">
        <div class="col-md-5 order-md-2"><img class="d-block w-270 m-auto" :src="logoAboutDelivery" alt="Delivery">
        </div>
        <div class="col-md-7 order-md-1 text-md-left text-center">
            <div class="mt-30 hidden-md-up"></div>
            <h2>{{$t("aboutDelivery.title")}}</h2>
            <p class="text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id purus at risus
                pellentesque faucibus a quis eros. In eu fermentum leo. Integer ut eros lacus. Proin ut accumsan leo.
                Morbi vitae est eget dolor consequat aliquam eget quis dolor. Mauris rutrum fermentum erat, at euismod
                lorem pharetra nec. Duis erat lectus, ultrices euismod sagittis at, pharetra eu nisl. Phasellus id ante
                at velit tincidunt hendrerit.</p><a class="text-decoration-none" href="#">Shipping Details&nbsp;<i
                class="material-icons keyboard_arrow_right lead"></i></a>
        </div>
    </section>
</template>

<script>
import logoAboutDelivery from "../../../../assets/img/features/02.jpg";

export default {
    name: "AboutDelivery",
    data() {
        return {
            logoAboutDelivery,
        };
    },
};
</script>

<style scoped>

</style>